import Vue from "vue";
import VueRouter from "vue-router";

// ============================== Start Views ==============================
import Home from "../views/Home.vue"; // Home

// ********** Children
import PageHome from "../views/children/HomePage.vue";

// ========== Start HomePage ==========
import Homepage from "../views/children/Homepage/Home.vue";

import HomeMeta from "../views/children/Homepage/Meta.vue";

// **** Start home Intro
import homeIntro from "../views/children/Homepage/Intro/Home.vue";
// Add
import AddIntro from "../views/children/Homepage/Intro/Add.vue";
// Edit
import EditIntro from "../views/children/Homepage/Intro/Edit.vue";
// Show Intro
import ShowIntro from "../views/children/Homepage/Intro/Show.vue";
// Meta Home

// **** End home Intro

// **** Start WhyUs
import WhyUs from "../views/children/Homepage/WhyUs/Home.vue";
// Add
import AddWhyUs from "../views/children/Homepage/WhyUs/Add.vue";
// Edit
// import EditWhyUs  from "../views/children/Homepage/WhyUs/Edit.vue";
// Show  Why us
import ShowWhyUs from "../views/children/Homepage/WhyUs/Show.vue";
// Update  Why us
import UpdateWhyUs from "../views/children/Homepage/WhyUs/UpdateSection.vue";
// **** End WhyUs
// ========== End HomePage ==========

// ========== Start Slider ==========
import TermsHome from "../views/children/Terms/Home.vue";
// Show All
import AllTerms from "../views/children/Terms/ShowAll.vue";
// Add
import AddTerm from "../views/children/Terms/Add.vue";
// Edit
import EditTerm from "../views/children/Terms/Edit.vue";
// ========== End Slider ==========
// ========== Start Slider ==========
import PolicyHome from "../views/children/Policy/Home.vue";
// Show All
import AllPolicy from "../views/children/Policy/ShowAll.vue";
// Add
import AddPolicy from "../views/children/Policy/Add.vue";
// Edit
import EditPolicy from "../views/children/Policy/Edit.vue";
// ========== End Slider ==========

// ========== Start Certificates ==========
import CertificatesHome from "../views/children/Certificates/Home.vue";
// Show All
import AllCertificates from "../views/children/Certificates/ShowAll.vue";
// Add
import AddCertificate from "../views/children/Certificates/Add.vue";
// Edit
import EditCertificate from "../views/children/Certificates/Edit.vue";
// ========== End Certificates ==========

// ========== Start Technologies ==========
import TechnologiesHome from "../views/children/Technologies/Home.vue";
// Show All
import AllTechnologies from "../views/children/Technologies/ShowAll.vue";
// Add
import AddTechnology from "../views/children/Technologies/Add.vue";
// Edit
import EditTechnology from "../views/children/Technologies/Edit.vue";
// ========== End Technologies ==========

// ========== Start Technologies ==========
import ToolsHome from "../views/children/Tools/Home.vue";
// Show All
import AllTools from "../views/children/Tools/ShowAll.vue";
// Add
import AddTool from "../views/children/Tools/Add.vue";
// Edit
import EditTool from "../views/children/Tools/Edit.vue";
// ========== End Technologies ==========

// ========== Start Technologies ==========
import SubscribeHome from "../views/children/Subscribe/Home.vue";
// Show All
import AllSubscribe from "../views/children/Subscribe/ShowAll.vue";
// Show
import SendSubscribe from "../views/children/Subscribe/Send.vue";
// ========== End Technologies ==========

// ========== Start services-categories ==========
import CareerCategoriesHome from "../views/children/CareersCategory/Home.vue";
// Show All
import AllCareerCategories from "../views/children/CareersCategory/ShowAll.vue";
// Add
import AddCareerCategory from "../views/children/CareersCategory/Add.vue";
// Edit
import EditCareerCategory from "../views/children/CareersCategory/Edit.vue";
// ========== End services-categories ==========

// ========== Start Projects ==========
import ProjectsHome from "../views/children/Projects/Home.vue";
// Show All
import AllProjects from "../views/children/Projects/ShowAll.vue";
// Add
import AddProject from "../views/children/Projects/Add.vue";
// Edit
import EditProject from "../views/children/Projects/Edit.vue";
// Show Project
import ShowProject from "../views/children/Projects/Show.vue";
// Meta Project
import MetaProject from "../views/children/Projects/Meta.vue";
// ========== End Projects ==========

// ========== Start Clients ==========
import ClientsHome from "../views/children/Reviews/Home.vue";
// Show All
import AllClients from "../views/children/Reviews/ShowAll.vue";
// Add
import AddClient from "../views/children/Reviews/Add.vue";
// Edit
import EditClient from "../views/children/Reviews/Edit.vue";
// ========== End Clients ==========

// ========== Start Partners ==========
import PartnersHome from "../views/children/Partners/Home.vue";
// Show All
import AllPartners from "../views/children/Partners/ShowAll.vue";
// Add
import AddPartner from "../views/children/Partners/Add.vue";
// Edit
import EditPartner from "../views/children/Partners/Edit.vue";
// Update Section
import UpdateSectionPartner from "../views/children/Partners/UpdateSection.vue";
// ========== End Partners ==========

// ========== Start Branches ==========
import BranchesHome from "../views/children/Branches/Home.vue";
// Show All
import AllBranches from "../views/children/Branches/ShowAll.vue";
// Add
import AddBranch from "../views/children/Branches/Add.vue";
// Edit
import EditBranch from "../views/children/Branches/Edit.vue";
// ========== End Branches ==========

// ========== Start Careers ==========
import CareersHome from "../views/children/Careers/Home.vue";
// Show All
import AllCareers from "../views/children/Careers/ShowAll.vue";
// Add
import AddCareer from "../views/children/Careers/Add.vue";
// Edit
import EditCareer from "../views/children/Careers/Edit.vue";
// Show Product
// import ShowCareer from '../views/children/Blogs/Show.vue'
// Meta Blog
import MetaCareer from "../views/children/Careers/Meta.vue";
// ========== End Careers ==========

// ========== Start Careers Applicant ==========
import CareersApplicantHome from "../views/children/CareerApplicant/Home.vue";
// Show All
import AllCareersApplicant from "../views/children/CareerApplicant/ShowAll.vue";

import ShowCareersApplicant from "../views/children/CareerApplicant/Show.vue";

// ========== End Careers ==========

// ========== Start Blogs ==========
import BlogsHome from "../views/children/Blogs/Home.vue";
// Show All
import AllBlogs from "../views/children/Blogs/ShowAll.vue";
// Add
import AddBlog from "../views/children/Blogs/Add.vue";
// Edit
import EditBlog from "../views/children/Blogs/Edit.vue";
// Show Product
import ShowBlog from "../views/children/Blogs/Show.vue";
// Meta Blog
import MetaBlog from "../views/children/Blogs/Meta.vue";
// ========== End Blogs ==========

// ========== Start Users ==========
// Crud
import UsersHome from "../views/children/Users/Home.vue";
import AllUserss from "../views/children/Users/ShowAll.vue";
import AddUsers from "../views/children/Users/Add.vue";
import EditUsers from "../views/children/Users/Edit.vue";
// Profile
import UserShowHome from "../views/children/Users/UserProfile/AdminShowHome.vue";
import UserCards from "../views/children/Users/UserProfile/children/Cards.vue";
import UserPersonalData from "../views/children/Users/UserProfile/children/PersonalData.vue";

import ShowFollowersUser from "../views/children/Users/UserProfile/children/Followers.vue";
import ShowfollowingUser from "../views/children/Users/UserProfile/children/Following.vue";
import ChatsUser from "../views/children/Users/UserProfile/children/Chats/ShowAll.vue";
import SingleChat from "../views/children/Users/UserProfile/children/Chats/Show.vue";
// ========== End Users ==========

// ========== Start Transaction ==========
import TransactionsHome from "../views/children/Transactions/Home.vue";
// All Transaction
import Transactions from "../views/children/Transactions/Transactions.vue";
// Single Transaction
import ShowTransaction from "../views/children/Transactions/Show.vue";
// ========== End Transaction ==========

// ========== Start Stock Tracking ==========
import StockTrackingHome from "../views/children/StockTracking/Home.vue";
// All Stock
import StockTracking from "../views/children/StockTracking/ShowAll.vue";
import StockTrackingShow from "../views/children/StockTracking/Show.vue";
// ========== End Stock Tracking ==========

// ========== Start Notifications ==========
import NotificationsHome from "../views/children/Notifications/Home.vue";
// All Notifications
import Notifications from "../views/children/Notifications/ShowAll.vue";
// Add Notification
import AddNotification from "../views/children/Notifications/Add.vue";
// Single Notification
import ShowNotification from "../views/children/Notifications/Show.vue";
// ========== End Notifications ==========

// ========== Start Messages ==========
import MessagessHome from "../views/children/Messages/Home.vue";

// Show GeneralMessages
import GeneralMessages from "../views/children/Messages/General.vue";
// Show UnreadMessages
import ReplyMessage from "../views/children/Messages/reply.vue";
// Show readed Messages
// import ReadedMessages from '../views/children/Messages/Readed.vue'

// Show With Services Messages
import WithServicesMessages from "../views/children/Messages/with-service.vue";
// import UnreadWithServicesMessages from '../views/children/Messages/Unread-with-service.vue'

// ========== End Messages ==========

// ========== Start Phone Code ==========

import PhoneCodesHome from "../views/children/PhoneCode/Home.vue";
// Show All
import AllPhoneCodes from "../views/children/PhoneCode/ShowAll.vue";
// Add
import AddPhoneCode from "../views/children/PhoneCode/Add.vue";
// Edit
import EditPhoneCode from "../views/children/PhoneCode/Edit.vue";

// ========== End Phone Code ==========
// ========== Start Admins ==========
// Crud
import AdminHome from "../views/children/Admins/Home.vue";
import AllAdmins from "../views/children/Admins/ShowAll.vue";
import AddAdmin from "../views/children/Admins/Add.vue";
import EditAdmin from "../views/children/Admins/Edit.vue";
// Profile
import AdminShowHome from "../views/children/Admins/AdminProfile/AdminShowHome.vue";
import Cards from "../views/children/Admins/AdminProfile/children/Cards.vue";
import PersonalData from "../views/children/Admins/AdminProfile/children/PersonalData.vue";
// ========== End Admins ==========

// ========== Start Settings ==========
// import SettingsHome from "../views/children/Settings/Home.vue";
import globalSettings from "../views/children/Settings/Global/index.vue";

// ABOUT
import faqsHome from "../views/children/FQuestions/Home.vue";
import Allfaqs from "../views/children/FQuestions/ShowAll.vue";
import Addfaqs from "../views/children/FQuestions/Add.vue";
import Editfaqs from "../views/children/FQuestions/Edit.vue";
// faqs
import AboutHome from "../views/children/About/Home.vue";
import UpdateAbout from "../views/children/About/Update.vue";
import ShowAbout from "../views/children/About/Show.vue";
import MetaAbout from "../views/children/About/Meta.vue";
// Terms
// import TermsHome from '../views/children/Settings/Terms/Home.vue'
import ContactMessages from "../views/children/Settings/ContactMessages/Home.vue";
import ContactMessagesShow from "../views/children/Settings/ContactMessages/ShowAll.vue";
import ReplayContactMessages from "../views/children/Settings/ContactMessages/Edit.vue";

import ProfileHome from "../views/children/Settings/Profile/Home.vue";
import ProfileShow from "../views/children/Settings/Profile/Show.vue";
import EditProfile from "../views/children/Settings/Profile/Edit.vue";
import AddProfile from "../views/children/Settings/Profile/Add.vue";

import MailsHome from "../views/children/Settings/PublicMails/Home.vue";
import MailsShow from "../views/children/Settings/PublicMails/ShowAll.vue";
// import EditMails from '../views/children/Settings/PublicMails/Edit.vue'
import UpdateMails from "../views/children/Settings/PublicMails/update.vue";

// ========== End Settings ==========

// ********** Auth
import Login from "../views/Auth/Login.vue";

// ********** NotFound
import NotFound from "../views/NotFound.vue";

// ============================== End Views ==============================

// Vuex store
import store from "../store/index";
let router = null;
window.rootRouter = router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Main
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "",
          name: "PageHome",
          component: PageHome,
        },

        // ========== Start Slider ==========
        // {
        //   path: '/sliders',
        //   component: SliderHome,
        //   children: [
        //     // Show All
        //     {
        //       path: '',
        //       name: 'AllSliders',
        //       component: AllSliders,
        //     },
        //     // Add
        //     {
        //       path: 'add',
        //       name: 'AddSlider',
        //       component: AddSlider,
        //     },
        //     // Edit
        //     {
        //       path: 'edit/:id',
        //       name: 'EditSlider',
        //       component: EditSlider,
        //       props: true,
        //     },
        //   ],
        // },
        // ========== End Slider ==========
        // ========== Start Homepage ==========
        // Home Intro
        {
          path: "/home_page",
          component: Homepage,
          children: [
            {
              path: "intro",
              component: homeIntro,
              children: [
                {
                  path: "add",
                  name: "AddIntro",
                  component: AddIntro,
                },
                {
                  path: "edit/:id",
                  name: "EditIntro",
                  component: EditIntro,
                  props: true,
                },
                // show
                {
                  path: "",
                  name: "ShowTnro",
                  component: ShowIntro,
                },
              ],
            },

            // Why us
            {
              path: "why_us",
              component: WhyUs,
              children: [
                // Add
                {
                  path: "add",
                  name: "AddWhyUs",
                  component: AddWhyUs,
                },
                // Update Section Brif
                {
                  path: "update",
                  name: "UpdateWhyUs",
                  component: UpdateWhyUs,
                },
                // Edit
                // {
                //   path: "edit/:id",
                //   name: "EditWhyUs",
                //   component: EditWhyUs,
                //   props: true,
                // },
                // show
                {
                  path: "show",
                  name: "ShowWhyUs",
                  component: ShowWhyUs,
                },
              ],
            },
            {
              path: "meta",
              component: HomeMeta,
            },

            // ========== End Homepage ==========
          ],
        },

        // ========== Start Certificates ==========
        {
          path: "/certificates",
          component: CertificatesHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCertificates",
              component: AllCertificates,
            },
            // Add
            {
              path: "add",
              name: "AddCertificate",
              component: AddCertificate,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditCertificate",
              component: EditCertificate,
              props: true,
            },
          ],
        },
        // ========== End Certificates ==========

        // ========== Start Certificates ==========
        {
          path: "/career-applicant",
          component: CareersApplicantHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllCareersApplicant",
              component: AllCareersApplicant,
            },
            {
              path: "show/:id",
              name: "ShowCareersApplicant",
              component: ShowCareersApplicant,
              props: true,
            },
          ],
        },
        // ========== End Certificates ==========

        // ========== Start Messages ==========
        {
          path: "/messages",
          component: MessagessHome,
          children: [
            // Unread
            {
              path: "reply/:id",
              name: "ReplyMessage",
              component: ReplyMessage,
              props: true,
            },
            {
              path: "general",
              name: "GeneralMessages",
              component: GeneralMessages,
            },
            // Service
            {
              path: "with-service",
              name: "WithServicesMessages",
              component: WithServicesMessages,
            },
          ],
        },
        // ========== End Messages ==========
        // ******* Start  permissions-categories *******
        {
          path: "/permission-categories",
          component: () =>
            import("@/views/children/PermissionCategory/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-permission-category",
              component: () =>
                import("@/views/children/PermissionCategory/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-permission-category",
              component: () =>
                import("@/views/children/PermissionCategory/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-permission-category",
              component: () =>
                import("@/views/children/PermissionCategory/Form.vue"),
            },
          ],
        },
        // ******* End  permissions-categories *******
        // ******* Start  Permission *******
        {
          path: "/permissions",
          component: () => import("@/views/children/Permissions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPermissions",
              component: () =>
                import("@/views/children/Permissions/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "EditPermission",
              component: () => import("@/views/children/Permissions/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "AddPermission",
              component: () => import("@/views/children/Permissions/Form.vue"),
            },
          ],
        },
        // ******* End  Permission *******
        // ******* Start  permissions-labels *******
        {
          path: "/permission-labels",
          component: () => import("@/views/children/PermissionLabels/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-permission-labels",
              component: () =>
                import("@/views/children/PermissionLabels/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-permission-label",
              component: () =>
                import("@/views/children/PermissionLabels/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-permission-label",
              component: () =>
                import("@/views/children/PermissionLabels/Form.vue"),
            },
          ],
        },
        // ******* End  roles *******
        // ========== Start medias ==========

        {
          path: "/project-medias",
          component: () => import("../views/children/project-medias/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "All-project-medias",
              component: () =>
                import("../views/children/project-medias/ShowAll.vue"),
            },
            // Add
            {
              path: "Form/:id?",
              name: "Form-medias",
              props: true,
              component: () =>
                import("../views/children/project-medias/Form.vue"),
            },

            {
              path: "Form/:id?/:slug?",
              name: "Showmedias",
              component: () =>
                import("../views/children/project-medias/Form.vue"),
              props: true,
            },
            // Meta
          ],
        },
        // ========== End Services ==========
        // ========== Start Services ==========

        {
          path: "/services",
          component: () => import("../views/children/Services/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllServices",
              component: () => import("../views/children/Services/ShowAll.vue"),
            },
            // Add
            {
              path: "Form/:id?",
              name: "FormService",
              props: true,
              component: () => import("../views/children/Services/Form.vue"),
            },

            {
              path: "Form/:id?/:slug?",
              name: "ShowService",
              component: () => import("../views/children/Services/Form.vue"),
              props: true,
            },
            // Meta
            {
              path: "meta/:id",
              name: "MetaService",
              component: () => import("../views/children/Services/Meta.vue"),
              props: true,
            },
          ],
        },
        // ========== End Services ==========
        // ========== Start Solutions ==========

        {
          path: "/solutions",
          component: () => import("../views/children/Solutions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSolutions",
              component: () =>
                import("../views/children/Solutions/ShowAll.vue"),
            },
            // Add
            {
              path: "Form/:id?",
              name: "FormSolutions",
              props: true,
              component: () => import("../views/children/Solutions/Form.vue"),
            },

            {
              path: "Form/:id?/:slug?",
              name: "ShowSolutions",
              component: () => import("../views/children/Solutions/Form.vue"),
              props: true,
            },
            // Meta
            {
              path: "meta/:id",
              name: "MetaSolutions",
              component: () => import("../views/children/Solutions/Meta.vue"),
              props: true,
            },
          ],
        },
        // ========== End Solutions ==========
        // ========== Start Systems ==========

        {
          path: "/systems",
          component: () => import("../views/children/Systems/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSystems",
              component: () => import("../views/children/Systems/ShowAll.vue"),
            },
            // Add
            {
              path: "Form/:id?",
              name: "FormSystem",
              props: true,
              component: () => import("../views/children/Systems/Form.vue"),
            },

            {
              path: "Form/:id?/:slug?",
              name: "ShowSystem",
              component: () => import("../views/children/Systems/Form.vue"),
              props: true,
            },
            // Meta
            {
              path: "meta/:id",
              name: "MetaSystem",
              component: () => import("../views/children/Systems/Meta.vue"),
              props: true,
            },
          ],
        },
        // ========== End Systems ==========

        // ========== End  Roles ==========
        {
          path: "/roles",
          component: () => import("@/views/children/Roles/Home.vue"),
          children: [
            // Show All
            {
              path: "",
              name: "ShowAll",
              component: () => import("@/views/children/Roles/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "editRole",
              component: () => import("@/views/children/Roles/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "addRole",
              component: () => import("@/views/children/Roles/Form.vue"),
            },
          ],
        },
        // ========== End  Roles ==========

        // ========== Start Partners ==========
        {
          path: "/partners",
          component: PartnersHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllPartners",
              component: AllPartners,
            },
            // Add
            {
              path: "add",
              name: "AddPartner",
              component: AddPartner,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditPartner",
              component: EditPartner,
              props: true,
            },
            // Update Section
            {
              path: "update",
              name: "UpdateSectionPartner",
              component: UpdateSectionPartner,
            },
          ],
        },
        // ========== End Partners ==========

        // ========== Start Clients ==========
        {
          path: "/reviews",
          component: ClientsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllClients",
              component: AllClients,
            },
            // Add
            {
              path: "add",
              name: "AddClient",
              component: AddClient,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditClient",
              component: EditClient,
              props: true,
            },
          ],
        },
        // ========== End Clients ==========

        // ========== Start Projects ==========
        {
          path: "/projects",
          component: ProjectsHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllProjects",
              component: AllProjects,
            },
            // Add
            {
              path: "add",
              name: "AddProject",
              component: AddProject,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditProject",
              component: EditProject,
              props: true,
            },
            // Show
            {
              path: "show/:id",
              name: "ShowProject",
              component: ShowProject,
              props: true,
            },
            // Show
            {
              path: "meta/:id",
              name: "MetaProject",
              component: MetaProject,
              props: true,
            },
          ],
        },
        // ========== End Projects ==========

        // ========== Start Blogs ==========
        {
          path: "/blogs",
          component: BlogsHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllBlogs",
              component: AllBlogs,
            },
            // Add
            {
              path: "add",
              name: "AddBlog",
              component: AddBlog,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditBlog",
              component: EditBlog,
              props: true,
            },
            // Show
            {
              path: "show/:id",
              name: "ShowBlog",
              component: ShowBlog,
              props: true,
            },
            // Meta
            {
              path: "meta/:id",
              name: "MetaBlog",
              component: MetaBlog,
              props: true,
            },
          ],
        },
        // ========== End Blogs ==========

        // ========== Start Branches ==========
        {
          path: "/branches",
          component: BranchesHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllBranches",
              component: AllBranches,
            },
            // Add
            {
              path: "add",
              name: "AddBranch",
              component: AddBranch,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditBranch",
              component: EditBranch,
              props: true,
            },
          ],
        },
        // ========== End Branches ==========

        // ========== Start Technologies ==========
        {
          path: "/technologies",
          component: TechnologiesHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllTechnologies",
              component: AllTechnologies,
            },
            // Add
            {
              path: "add",
              name: "AddTechnology",
              component: AddTechnology,
            },
            // Edit
            {
              path: "edit/:id",
              name: "Edit-Technology",
              component: EditTechnology,
              props: true,
            },
          ],
        },
        // ========== End Technologies ==========

        // ========== Start services-categories ==========
        {
          path: "/services-categories",
          component: () =>
            import("../views/children/ServicesCategory/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-services-categories",
              component: () =>
                import("../views/children/ServicesCategory/ShowAll.vue"),
            },
            // Add
            {
              path: "add",
              name: "add-service-category",
              component: () =>
                import("../views/children/ServicesCategory/Add.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "edd-service-category",
              component: () =>
                import("../views/children/ServicesCategory/Edit.vue"),
              props: true,
            },
          ],
        },
        // ========== End services-categories ==========

        // ========== Start solutions-categories ==========
        {
          path: "/solutions-categories",
          component: () =>
            import("../views/children/SolutionsCategory/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-solutions-categories",
              component: () =>
                import("../views/children/SolutionsCategory/ShowAll.vue"),
            },
            // Add
            {
              path: "add",
              name: "add-solution-category",
              component: () =>
                import("../views/children/SolutionsCategory/Add.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "edd-solution-category",
              component: () =>
                import("../views/children/SolutionsCategory/Edit.vue"),
              props: true,
            },
          ],
        },
        // ========== End solutions-categories ==========
        // ========== Start ProjectsCategory-categories ==========
        {
          path: "/projects-categories",
          component: () =>
            import("../views/children/ProjectsCategory/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-projects-categories",
              component: () =>
                import("../views/children/ProjectsCategory/ShowAll.vue"),
            },
            // Add
            {
              path: "add",
              name: "add-project-category",
              component: () =>
                import("../views/children/ProjectsCategory/Add.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "edd-project-category",
              component: () =>
                import("../views/children/ProjectsCategory/Edit.vue"),
              props: true,
            },
          ],
        },
        // ========== End ProjectsCategory-categories ==========

        // ========== Start Technologies ==========
        {
          path: "/careers-categories",
          component: CareerCategoriesHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllCareerCategories",
              component: AllCareerCategories,
            },
            // Add
            {
              path: "add",
              name: "AddCareerCategory",
              component: AddCareerCategory,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditCareerCategory",
              component: EditCareerCategory,
              props: true,
            },
          ],
        },
        // ========== End CareerCategories ==========

        // ========== Start subscribe ==========
        {
          path: "/subscribe",
          component: SubscribeHome,
          children: [
            // Show All
            {
              path: "show",
              name: "AllSubscribe",
              component: AllSubscribe,
            },
            // Add
            {
              path: "send",
              name: "SendSubscribe",
              component: SendSubscribe,
            },
          ],
        },
        // ========== End subscribe ==========
        // ========== Start Careers ==========
        {
          path: "/careers",
          component: CareersHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllCareers",
              component: AllCareers,
            },
            // Add
            {
              path: "add",
              name: "AddCareer",
              component: AddCareer,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditCareer",
              component: EditCareer,
              props: true,
            },
            // Meta
            {
              path: "meta/:id",
              name: "MetaCareer",
              component: MetaCareer,
              props: true,
            },
          ],
        },
        // ========== End Careers ==========
        // ========== Start Terms ==========
        {
          path: "/terms",
          component: TermsHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllTerms",
              component: AllTerms,
            },
            // Add
            {
              path: "add",
              name: "AddTerm",
              component: AddTerm,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditTerm",
              component: EditTerm,
              props: true,
            },
          ],
        },
        // ========== End Terms ==========
        // ========== Start Policy ==========
        {
          path: "/policy",
          component: PolicyHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllPolicy",
              component: AllPolicy,
            },
            // Add
            {
              path: "add",
              name: "AddPolicy",
              component: AddPolicy,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditPolicy",
              component: EditPolicy,
              props: true,
            },
          ],
        },
        // ========== End Policy ==========
        // ========== Start Tools ==========
        {
          path: "/tools",
          component: ToolsHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllTools",
              component: AllTools,
            },
            // Add
            {
              path: "add",
              name: "AddTool",
              component: AddTool,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditTechnology",
              component: EditTool,
              props: true,
            },
          ],
        },
        // ========== End Tools ==========

        // ========== Start Settings ==========
        {
          alias: "/about",
          path: "about",
          component: AboutHome,
          children: [
            // Show
            {
              path: "show",
              name: "aboutShow",
              component: ShowAbout,
            },
            // meta
            {
              path: "meta",
              name: "MetaAbout",
              component: MetaAbout,
            },
            {
              path: "update",
              name: "update",
              component: UpdateAbout,
            },
          ],
        },
        {
          path: "/faqs",
          component: faqsHome,
          children: [
            {
              path: "",
              name: "Allfaqs",
              component: Allfaqs,
            },
            {
              path: "add",
              name: "Addfaqs",
              component: Addfaqs,
            },
            {
              path: "edit/:id",
              name: "Editfaqs",
              component: Editfaqs,
              props: true,
            },
          ],
        },
        {
          alias: "/settings/profile",
          path: "profile",
          component: ProfileHome,
          children: [
            // Show
            {
              path: "",
              name: "ProfileShow",
              component: ProfileShow,
            },
            {
              path: "update",
              name: "AddProfile",
              component: AddProfile,
              props: true,
            },
            // Edit
            {
              path: "edit_password",
              name: "EditProfile",
              component: EditProfile,
              // props: true,
            },
          ],
        },
        {
          alias: "/settings/mails",
          path: "mails",
          component: MailsHome,
          children: [
            // Show
            {
              path: "",
              name: "MailsShow",
              component: MailsShow,
            },
            {
              path: "update",
              name: "update-mail",
              component: UpdateMails,
              // props:true
            },
            // Edit
            // {
            //   path: 'edit/:id',
            //   name: 'EditMails',
            //   component: EditMails,
            //   props: true,
            // },
          ],
        },
        // Home Stting
        {
          path: "/setting",
          component: globalSettings,
          children: [
            {
              path: "/profile",
              component: ProfileHome,
              children: [
                {
                  path: "/add",
                  name: "Add-Profile",
                  component: AddProfile,
                },
                {
                  path: "/edit_password",
                  name: "Edit-Intro",
                  component: EditProfile,
                  // props: true,
                },
                // show
                {
                  path: "",
                  name: "Profile-Show",
                  component: ProfileShow,
                },
              ],
            },
          ],
        },
        {
          alias: "/settings/contact_messages",
          path: "ContactMessages",
          component: ContactMessages,
          children: [
            // Show
            {
              path: "",
              name: "ContactMessagesShow",
              component: ContactMessagesShow,
            },
            // Replay
            {
              path: "replay/:id",
              name: "ReplayContactMessages",
              component: ReplayContactMessages,
              props: true,
            },
          ],
        },
        // {
        //   path: 'settings/global',
        //   name: 'globalSettings',
        //   component: globalSettings,
        // },
        // ========== End Settings ==========

        // ========== Start Users ==========
        {
          path: "/users",
          component: UsersHome,
          children: [
            {
              path: "",
              name: "AllUserss",
              component: AllUserss,
            },
            {
              path: "add",
              name: "AddUsers",
              component: AddUsers,
            },
            {
              path: "edit/:id",
              name: "EditUsers",
              component: EditUsers,
              props: true,
            },
            // Show Admin
            {
              path: "show/:id",
              component: UserShowHome,
              props: true,
              children: [
                {
                  path: "",
                  name: "UserCards",
                  component: UserCards,
                  props: true,
                },
                {
                  path: "data",
                  name: "UserPersonalData",
                  component: UserPersonalData,
                  props: true,
                },

                {
                  path: "data/followers",
                  name: "ShowFollowersUser",
                  component: ShowFollowersUser,
                  props: true,
                },
                {
                  path: "data/following",
                  name: "ShowfollowingUser",
                  component: ShowfollowingUser,
                  props: true,
                },
                {
                  path: "data/chats",
                  name: "ChatsUser",
                  component: ChatsUser,
                  props: true,
                },
                {
                  path: "data/chats/single/:chatID",
                  name: "SingleChat",
                  component: SingleChat,
                  props: true,
                },
              ],
            },
          ],
        },
        // ========== End Users ==========

        // ========== Start Transactions ==========
        {
          path: "/transactions",
          component: TransactionsHome,
          children: [
            // All Transaction
            {
              path: "all-transactions",
              name: "Transactions",
              component: Transactions,
            },
            {
              path: "show/:id",
              name: "ShowTransaction",
              component: ShowTransaction,
              props: true,
            },
          ],
        },
        // ========== End Transactions ==========

        // ========== Start StockTracking ==========
        {
          path: "/stock-tracking",
          component: StockTrackingHome,
          children: [
            // All StockTracking
            {
              path: "all-stock",
              name: "AllStock",
              component: StockTracking,
            },
            {
              path: "show/:id",
              name: "StockTrackingShow",
              component: StockTrackingShow,
            },
          ],
        },
        // ========== End StockTracking ==========

        // ========== Start Notifications ==========
        {
          path: "/notifications",
          component: NotificationsHome,
          children: [
            // All Notifications
            {
              path: "all-notifications",
              name: "Notifications",
              component: Notifications,
            },
            {
              path: "add",
              name: "AddNotification",
              component: AddNotification,
            },
            {
              path: "show/:id",
              name: "ShowNotification",
              component: ShowNotification,
              props: true,
            },
          ],
        },
        // ========== End Notifications ==========

        // ========== Start PhoneCodes ==========
        {
          path: "/phone-codes",
          component: PhoneCodesHome,
          children: [
            // Show All
            {
              path: "",
              name: "AllPhoneCodes",
              component: AllPhoneCodes,
            },
            // Add
            {
              path: "add",
              name: "AddPhoneCode",
              component: AddPhoneCode,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EditPhoneCode",
              component: EditPhoneCode,
              props: true,
            },
          ],
        },
        // ========== End PhoneCodes ==========

        // ========== Start Admins ==========
        {
          path: "/admins",
          component: AdminHome,
          children: [
            {
              path: "show-all",
              name: "AllAdmins",
              component: AllAdmins,
            },
            {
              path: "add",
              name: "AddAdmin",
              component: AddAdmin,
            },
            {
              path: "edit/:id",
              name: "EditAdmin",
              component: EditAdmin,
              props: true,
            },
            // Show Admin
            {
              path: "show/:id",
              component: AdminShowHome,
              props: true,
              children: [
                {
                  path: "",
                  name: "Cards",
                  component: Cards,
                  props: true,
                },
                {
                  path: "data",
                  name: "PersonalData",
                  component: PersonalData,
                  props: true,
                },
              ],
            },
          ],
        },
        // ========== End Admins ==========

        // ========== Start Permissions ==========
        // {
        //   path: '/permissions',
        //   component: PermissionsHome,
        //   children: [
        //     // Show All
        //     {
        //       path: '',
        //       name: 'AllPermissions',
        //       component: AllPermissions,
        //     },
        //     // Add
        //     {
        //       path: 'add',
        //       name: 'AddPermission',
        //       component: AddPermission,
        //     },
        //     // Edit
        //     {
        //       path: 'edit/:id',
        //       name: 'EditPermission',
        //       component: EditPermission,
        //       props: true,
        //     },
        //   ],
        // },
        // ========== End Permissions ==========
      ],
    },

    // Auth
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    // NotFound
    { path: "/:notFound(.*)", name: "NotFound", component: NotFound },
  ],
});

const TOKEN = store.getters["auth_module/currentUser"].token;

router.beforeEach((to, _2, next) => {
  if (to.name !== "Login" && !TOKEN) {
    next({ name: "Login" });
  } else if (to.name == "Login" && TOKEN) {
    next("/");
  } else if (to.name == "Login" || to.name == "NotFound") {
    store.dispatch("sideNav_module/reseatBodyPadding");
    next();
  } else {
    next();
  }
});

Vue.use(VueRouter);
export default router;
